import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';
import styled from 'styled-components';

import { Pill, Tooltip, tokens } from '@treams/treams-ui';

const STYR_LOGO_URL = '/images/marketplace/styr.png';

const StyrPill = styled(Pill)`
	display: inline-flex;
	align-items: center;
	background-color: ${(props) => props.theme.colors.white};
	border: 1px solid ${tokens.border.subtle};
	padding: 6px 6px 4px;
`;

const StyrLogo = styled.img`
	display: block;
	height: 9px;
	width: auto;
`;

// Marker shown next to settings rows that came from the Styr enrichment connector.
// Source-of-truth checks live in the call sites (see `CompetenciesListContainer` and
// `JobTitlesListContainer`), so this component is purely presentational.
export function StyrBadge(props: { tooltip?: string; rightAligned?: boolean }) {
	const { t } = useTranslation();
	const tooltip = props.tooltip ?? t('settings.connectors.styr.badge.tooltip');

	const badge = (
		<Tooltip content={tooltip} portal>
			<StyrPill small>
				<StyrLogo src={STYR_LOGO_URL} alt="Styr" />
			</StyrPill>
		</Tooltip>
	);

	if (props.rightAligned) {
		return (
			<Flex alignItems="center" justifyContent="flex-end">
				{badge}
			</Flex>
		);
	}

	return badge;
}
